import { createApp } from 'vue';
import RarToIsoConverter from '@/Components/RarToIsoConverter.vue';
import '@styles/app.css';

createApp(RarToIsoConverter).mount('#rar-to-iso-converter');
